import { useInitialURLHash } from 'common/hooks/useInitialURLHash';
import { useMissingI18nKeysReporter } from 'common/hooks/useMissingI18nKeysReporter';
import { FC, PropsWithChildren } from 'react';

import { useMyRegionMiddleware, useYuzuMetaMiddleware } from './Middleware.hooks';

export const Middleware: FC<PropsWithChildren> = ({ children }) => {
  useInitialURLHash();
  useMissingI18nKeysReporter();
  useMyRegionMiddleware();
  useYuzuMetaMiddleware();

  return <>{children}</>;
};
